import { ReactNode } from "react";

import styles from "./Tabs.module.css";

export interface TabItem<Value extends string> {
  value: Value;
  label: string;
  // Иконка слева от подписи; цвет лучше брать из currentColor.
  icon?: ReactNode;
  // Счётчик рядом с подписью (например, непрочитанные).
  badge?: string;
}

interface Props<Value extends string> {
  items: TabItem<Value>[];
  // null — ни один таб не выбран.
  active: Value | null;
  onChange: (value: Value) => void;
  // Дополнительные стили таба и выбранного таба.
  tabClassName?: string;
  activeClassName?: string;
}

export const Tabs = <Value extends string>({
  items,
  active,
  onChange,
  tabClassName = "",
  activeClassName = "",
}: Props<Value>) => (
  <div className={styles.tabs}>
    {items.map(({ value, label, icon, badge }) => (
      <button
        key={value}
        type="button"
        className={`${styles.tab} ${tabClassName} ${value === active ? `${styles.activeTab} ${activeClassName}` : ""}`}
        onClick={() => onChange(value)}
      >
        {icon}
        {label}
        {badge && <span className={styles.badge}>{badge}</span>}
      </button>
    ))}
  </div>
);
